/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=59644ad7&scoped=true"
import script from "./wrapper.vue?vue&type=script&lang=js"
export * from "./wrapper.vue?vue&type=script&lang=js"
import style0 from "./wrapper.vue?vue&type=style&index=0&id=59644ad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59644ad7",
  null
  
)

export default component.exports